<template>
	<div class="friend-item" :class="active ? 'active' : ''" @contextmenu.prevent="showRightMenu($event)">
		<div class="friend-avatar">
			<head-image :size="42" :name="friend.nickName" :url="friend.headImage"
				:online="friend.online || friend.onlineWeb || friend.onlineApp">
			</head-image>
		</div>
		<div class="friend-info">
			<div class="friend-name">{{ displayName }}</div>
			<div class="friend-online">
				<i class="el-icon-monitor online" v-show="friend.onlineWeb" title="电脑设备在线">
					<span class="online-icon"></span>
				</i>
				<i class="el-icon-mobile-phone online" v-show="friend.onlineApp" title="移动设备在线">
					<span class="online-icon"></span>
				</i>
			</div>
		</div>
		<right-menu ref="rightMenu" @select="onSelectMenu"></right-menu>
		<slot></slot>
	</div>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';
import RightMenu from "../common/RightMenu.vue";

export default {
	name: "frinedItem",
	components: {
		HeadImage,
		RightMenu
	},
			data() {
		return {
			remarkMap: {}
				}
	},
	computed: {
		menuItems() {
			const items = [{
				key: 'CHAT',
				name: '发送消息',
				icon: 'el-icon-chat-dot-round'
			}];
			
			if (this.remarkMap[this.friend.id]) {
				// 如果已有备注，显示修改和删除选项
				items.push({
					key: 'EDIT_REMARK',
					name: '修改备注',
					icon: 'el-icon-edit'
				});
				items.push({
					key: 'DELETE_REMARK',
					name: '删除备注',
					icon: 'el-icon-delete',
					color: '#f56c6c'
				});
			} else {
				// 如果没有备注，显示添加选项
				items.push({
					key: 'ADD_REMARK',
					name: '添加备注',
					icon: 'el-icon-edit'
				});
			}
			
			items.push({
				key: 'DELETE',
				name: '删除好友',
				icon: 'el-icon-delete'
			});
			
			return items;
		},
		displayName() {
			return this.remarkMap[this.friend.id] || this.friend.nickName;
		}
	},
	mounted() {
		this.loadRemarks();
	},
	methods: {
		loadRemarks() {
			try {
				const remarks = localStorage.getItem('friend_remarks');
				if (remarks) {
					this.remarkMap = JSON.parse(remarks);
				}
			} catch (error) {
				console.error('加载备注失败:', error);
			}
		},
		saveRemarks() {
			try {
				localStorage.setItem('friend_remarks', JSON.stringify(this.remarkMap));
			} catch (error) {
				console.error('保存备注失败:', error);
			}
		},
		showRightMenu(e) {
			if (this.menu) {
				this.$refs.rightMenu.open(e, this.menuItems);
			}
		},
		onSelectMenu(item) {
			if (item.key === 'ADD_REMARK' || item.key === 'EDIT_REMARK') {
				this.addRemark();
			} else if (item.key === 'DELETE_REMARK') {
				this.deleteRemark();
			} else {
				this.$emit(item.key.toLowerCase(), this.friend);
			}
		},
		addRemark() {
			const currentRemark = this.remarkMap[this.friend.id] || '';
			this.$prompt('请输入好友备注', '添加备注', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputValue: currentRemark,
				inputPlaceholder: '请输入备注名称'
			}).then(({ value }) => {
				if (value && value.trim()) {
					const remark = value.trim();
					this.remarkMap[this.friend.id] = remark;
					this.saveRemarks();
					// 更新聊天显示名称
					this.chatStore.updateChatDisplayName(this.friend.id);
					this.$message.success('备注已保存');
				}
			}).catch(() => {
				// 用户取消
			});
		},
		deleteRemark() {
			this.$confirm(`确认删除好友"${this.remarkMap[this.friend.id]}"的备注吗？`, '确认删除', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				delete this.remarkMap[this.friend.id];
				this.saveRemarks();
				// 更新聊天显示名称
				this.chatStore.updateChatDisplayName(this.friend.id);
				this.$message.success('备注已删除');
			}).catch(() => {
				// 用户取消
			});
		}
	},
	props: {
		active: {
			type: Boolean
		},
		friend: {
			type: Object
		},
		menu: {
			type: Boolean,
			default: true
		}
	}

}
</script>

<style scope lang="scss">
.friend-item {
	height: 50px;
	display: flex;
	position: relative;
	padding: 5px 10px;
	align-items: center;
	white-space: nowrap;
	cursor: pointer;

	&:hover {
		background-color: #f7fafc; /* 更淡的灰色背景 */
	}

	&.active {
		background-color: #d4def5;
	}

	.friend-avatar {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.friend-info {
		flex: 1;
		display: flex;
		flex-direction: column;
		padding-left: 10px;
		text-align: left;

		.friend-name {
			font-size: var(--im-font-size);
			white-space: nowrap;
			overflow: hidden;
		}

		.friend-online {
			.online {
				font-weight: bold;
				padding-right: 2px;
				font-size: 16px;
				position: relative;
			}

			.online-icon {
				position: absolute;
				right: 0;
				bottom: 0;
				width: 6px;
				height: 6px;
				background: #05524b;
				border-radius: 50%;
				border: 1px solid white;
			}
		}
	}
}
</style>
